import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as appActions from "../../../_actions/appActions";

import isSidebarCollapsed from "../../../_selectors/appSelectors/isSidebarCollapsed";
import isRightBarOpen from "../../../_selectors/appSelectors/isRightBarOpen";
class PageHeader extends Component {
  _toggleCollapsedStatus = () => {
    const { collapseSidebar, isSidebarCollapsed } = this.props;
    collapseSidebar(!isSidebarCollapsed);
  };
  render() {
    const { isSidebarCollapsed, toggleRightBar, isRightBarOpen } = this.props;
    let _classNames = ["dev-page-sidebar-collapse"];
    isSidebarCollapsed ? _classNames.push("active") : null;
    return (
      <div className="dev-page-header">
        <div className="dph-logo">
          <Link to="/">AMST</Link>
          <a className={_classNames.join(" ")}>
            <div
              className="dev-page-sidebar-collapse-icon"
              onClick={this._toggleCollapsedStatus}
            >
              <span className="line-one" />
              <span className="line-two" />
              <span className="line-three" />
            </div>
          </a>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  isSidebarCollapsed: isSidebarCollapsed(state),
  isRightBarOpen: isRightBarOpen(state)
});
const mapDispatchToProps = dispatch => ({
  collapseSidebar: collapse => dispatch(appActions.collapseSidebar(collapse)),
  toggleRightBar: toggle => dispatch(appActions.toggleRightbar(toggle))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageHeader);



// WEBPACK FOOTER //
// ./src/_components/Layout/PageHeader/index.js